var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{attrs:{"app":""}},[_c('toolbar'),_c('menuRight'),_c('keep-alive',[_c('router-view',{attrs:{"name":"keepalive"}})],1),_c('router-view'),_c('footerx')],1)}
var staticRenderFns = []

export { render, staticRenderFns }